import { selectEventsInitWaitingMessage } from './../_selectors/events.selectors';
// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectEventsInStore, selectEventsPageLoading } from '../_selectors/events.selectors';

export class EventsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectEventsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectEventsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectEventsInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.resultCount);
			this.entitySubject.next(response.list);
		});
	}
}
